import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Drawer, type DrawerProps, Typography } from '@didaskill/ui/design-system';
import { globalMessages } from '@didaskill/ui/intl';

import { walletMessages } from '../DiscoveryDrawers.messages';
import * as styles from '../DiscoveryDrawers.styles';
import { DiscoveryWalletDrawerIllustration } from './DiscoveryWalletDrawerIllustration';

type DiscoveryWalletDrawerProps = {
  initialFillAmount: number;
  onClickPrevious: () => void;
  onClickContinue: () => void;
} & DrawerProps;

const DiscoveryWalletDrawerBase = ({
  initialFillAmount,
  onClickPrevious,
  onClickContinue,
  ...props
}: DiscoveryWalletDrawerProps) => {
  return (
    <Drawer position={Drawer.POSITIONS.FULL_SCREEN} css={styles.drawer} {...props}>
      <div />

      <div css={styles.drawerContent}>
        <DiscoveryWalletDrawerIllustration />

        <Typography variant={Typography.VARIANTS.HEADING_3}>
          <FormattedMessage
            {...walletMessages.TITLE}
            values={{
              amount: initialFillAmount,
            }}
          />
        </Typography>

        <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
          <FormattedMessage
            {...walletMessages.DESCRIPTION}
            values={{
              b: (chunks) => (
                <Typography variant={Typography.VARIANTS.BODY_MEDIUM_BOLD}>{chunks}</Typography>
              ),
            }}
          />
        </Typography>
      </div>

      <Drawer.Actions>
        <Drawer.Action outline onClick={onClickPrevious}>
          <FormattedMessage {...globalMessages.PREVIOUS} />
        </Drawer.Action>

        <Drawer.Action variant={Drawer.Action.VARIANTS.PRIMARY} onClick={onClickContinue}>
          <FormattedMessage {...globalMessages.CONTINUE} />
        </Drawer.Action>
      </Drawer.Actions>
    </Drawer>
  );
};

DiscoveryWalletDrawerBase.displayName = 'DiscoveryWalletDrawer';

export const DiscoveryWalletDrawer = memo(DiscoveryWalletDrawerBase);
